import { useEffect, useState } from "react";

const links = [
  { id: "founder", label: "Founder" },
  { id: "tribute", label: "Tribute" },
  { id: "technology", label: "Technology" },
  { id: "gallery", label: "Gallery" },
  { id: "awards", label: "Awards" },
  { id: "specifications", label: "Specs" },
  { id: "enquire", label: "Enquire" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="primary-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "py-4 bg-[#050B14]/85 backdrop-blur-md border-b border-white/5"
          : "py-6 bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-baseline gap-3 text-white"
        >
          <span className="font-serif-display text-2xl md:text-3xl tracking-tight">
            Marie&thinsp;·&thinsp;Joseph
          </span>
          <span className="hidden md:inline overline text-[10px]">
            Sunreef 80 Eco
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="text-xs uppercase tracking-[0.28em] text-white/70 hover:text-white transition-colors duration-500"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#enquire"
          data-testid="nav-enquire-cta"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 border border-[#E5D3B3]/60 text-[#E5D3B3] text-[11px] uppercase tracking-[0.28em] hover:bg-[#E5D3B3] hover:text-[#050B14] transition-colors duration-500"
        >
          Enquire
        </a>
      </div>
    </nav>
  );
}
